
import React from 'react';
import { cn } from '@/lib/utils';

interface ChartConfig {
  [key: string]: {
    label: string;
    color: string;
  };
}

interface ChartContainerProps {
  children: React.ReactNode;
  config: ChartConfig;
  className?: string;
  style?: React.CSSProperties;
}

export const ChartContainer: React.FC<ChartContainerProps> = ({ 
  children, 
  config, 
  className,
  style
}) => {
  // Convert config to CSS variables
  const cssVars = Object.entries(config).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [`--color-${key}`]: value.color
    };
  }, {});
  
  return (
    <div 
      className={cn("chart-container", className)} 
      style={{ 
        ...cssVars, 
        ...style
      }}
    >
      {children}
    </div>
  );
};

interface ChartTooltipContentProps {
  active?: boolean;
  payload?: any[];
  label?: string;
}

export const ChartTooltipContent: React.FC<ChartTooltipContentProps> = ({ 
  active, 
  payload, 
  label 
}) => {
  if (!active || !payload || !payload.length) {
    return null;
  }
  
  return (
    <div className="bg-background p-3 border rounded-md shadow-lg">
      <p className="text-sm font-medium mb-1">{label}</p>
      <div className="space-y-1">
        {payload.map((entry, index) => (
          <div key={`tooltip-${index}`} className="flex items-center">
            <div 
              className="w-3 h-3 rounded-full mr-2" 
              style={{ backgroundColor: entry.color }} 
            />
            <span className="text-xs">{entry.name}: </span>
            <span className="text-xs font-medium ml-1">
              {typeof entry.value === 'number' 
                ? entry.value.toLocaleString() 
                : entry.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
